import axios from "axios";
import { decrypt } from "../../utils/encryptDecrypt";

export const searchCustomHandler = (value, existData) => {
  const allData = existData;
  let filterData = null;
  if (value !== "") {
    // eslint-disable-next-line consistent-return, array-callback-return
    const filteredList = allData.filter((filter) => {
      if (filter?.exam_name.toLowerCase().includes(value.toLowerCase()) || filter?.description.toLowerCase().includes(value.toLowerCase())) {
        return filter;
      }
    });
    filterData = filteredList;
  } else {
    filterData = allData;
  }
  return filterData;
};

export const _retrieveToken = async () => {
  const value = await localStorage.getItem("app-token");
  return value;
};

export const _retrieveForgotToken = async () => {
  const value = await localStorage.getItem("forgot_token");
  return value;
};

export const _removeData = async () => {
  try {
    await localStorage.removeItem("app-token");
  } catch (error) {
    console.log(error);
  }
};

const http = axios.create({
  // baseURL: "http://localhost:5001/api/v1/backend",
  baseURL: "https://mqzmsqs7jf.execute-api.ap-south-1.amazonaws.com/tax-revenue/",
});

const authHttp = axios.create({
  // baseURL: "http://localhost:5001/api/v1/backend",
  baseURL: "https://mqzmsqs7jf.execute-api.ap-south-1.amazonaws.com/tax-revenue/",
});

authHttp.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      await _removeData();
      return Promise.reject(error);
    }
    return Promise.reject(error);

  }
);
authHttp.interceptors.request.use(
  async (config) => {
    const token = await _retrieveToken();
    const forgtoptoken = await _retrieveForgotToken();
    const t = token || forgtoptoken;
    if (t !== null && typeof t !== "undefined") {
      config.headers.Authorization = `Bearer ${decrypt(JSON.parse(t))}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export { authHttp };

export default http;
